import type { CheckoutState } from '../../state';

export const getStripePaymentType = (state: CheckoutState): string | null =>
    state.stripe?.paymentType || null;
